import {Outlet} from 'react-router-dom';

import RequiredAuth from 'components/base/SecureRoutes/RequiredAuth';
import {StaticConfig} from 'config/staticConfig';

const SecureRoutes = () => (StaticConfig.mobileApplicationLoader ? <Outlet /> : <RequiredAuth />);

export default SecureRoutes;
